import React from 'react';
import { useTranslation } from 'react-i18next';
import RequestKindIcon from './RequestKindIcon';
import { REQUEST_KIND_OPTIONS, requestOptionId } from '../../utils/requestKinds';
import { httpMethodLabelClass } from '../../utils/httpMethodLabelClass';

/**
 * What a request TAB shows before its title: the protocol's icon for GraphQL, WebSocket,
 * SSE and gRPC — and the coloured verb for plain HTTP, where the verb is the information.
 * `wide` = the fixed-width column of the "all tabs" list.
 */
export default function RequestTabBadge({ tab, method, wide = false }) {
  const { t } = useTranslation();
  const optionId = requestOptionId(tab);
  if (optionId === 'http') {
    return (
      <span className={`text-xxs font-semibold uppercase tracking-wide flex-shrink-0 ${wide ? 'w-12 text-left ' : ''}${httpMethodLabelClass(method)}`}>
        {method}
      </span>
    );
  }
  const option = REQUEST_KIND_OPTIONS.find((o) => o.id === optionId);
  return (
    <span
      role="img"
      aria-label={t(option.labelKey)}
      data-request-option={optionId}
      className="flex-shrink-0 flex items-center"
      style={wide ? { width: 48 } : undefined}
    >
      <RequestKindIcon optionId={optionId} size={13} />
    </span>
  );
}
